import styled from '@emotion/styled'

import { ApiAsset, ApiDistributionAlert } from '../../../api/_legacy/generated-api'
import {
  CheckboxWithLabel,
  LoadingSpinner,
  Space,
  TextInput,
  Typography
} from '../../../components/core-v2'
import {
  TablePagination,
  TablePaginationParams
} from '../../../components/core-v2/molecules/table-pagination'
import { FundsSearchFilter } from '../state/funds-slice'
import FundsView from '../templates/funds-view'
import { StyledContainer } from './funds-master-panel.styles'

export type FundsPanelProps = {
  funds: ApiAsset[]
  fundsAlerts: ApiDistributionAlert[]
  isLoading: boolean
  onPaginationChange: (updatedPagination: TablePaginationParams) => void
  onSearch: (updatedFilter: FundsSearchFilter) => void
  paginationParams: TablePaginationParams
  searchFilter: FundsSearchFilter
  totalNumAccounts: number
}

export const FundsPanel = ({
  funds,
  fundsAlerts,
  isLoading,
  onPaginationChange,
  onSearch,
  paginationParams,
  searchFilter,
  totalNumAccounts
}: FundsPanelProps) => {
  const onSearchText = (searchText: any) => {
    const clonedFilter = { ...searchFilter }
    clonedFilter.searchTerm = searchText
    onSearch(clonedFilter)
  }

  const onShowActiveOnlyChange = (checked: boolean) => {
    const clonedFilter = { ...searchFilter }
    clonedFilter.showAll = checked
    onSearch(clonedFilter)
  }
  const onShowNewFundsOnlyChange = (checked: boolean) => {
    const clonedFilter = { ...searchFilter }
    clonedFilter.showRequiringAction = checked
    onSearch(clonedFilter)
  }

  const StyledPagination = styled.div`
    border-top: solid 1px var(--White95);
  `

  return (
    <Space isflex flexDirection="column">
      <Space mt={6}>
        <TextInput
          key="txt_trade_search"
          hideBorder
          maxLength={64}
          value={searchFilter.searchTerm}
          onDebouncedValue={onSearchText}
        />
      </Space>
      <StyledContainer isflex className="funds-count-panel" justifyContent="space-between" pt={3}>
        <Space>
          {!isLoading && (
            <Space pt={1}>
              <Typography variant="sh2">{totalNumAccounts} results</Typography>
            </Space>
          )}
          <LoadingSpinner show={isLoading} />
        </Space>
      </StyledContainer>
      <Space isflex justifyContent="flex-end" py={3}>
        <Space mr={4}>
          <CheckboxWithLabel checked={searchFilter.showAll} onChange={onShowNewFundsOnlyChange}>
            All
          </CheckboxWithLabel>
        </Space>
        <CheckboxWithLabel
          checked={searchFilter.showRequiringAction}
          onChange={onShowActiveOnlyChange}
        >
          Requiring action
        </CheckboxWithLabel>
      </Space>

      <StyledPagination>
        <Space my={4}>
          <TablePagination pagination={paginationParams} onChange={onPaginationChange} />
        </Space>
      </StyledPagination>

      <FundsView key="funds_view" funds={funds} fundsAlerts={fundsAlerts} />
    </Space>
  )
}
